// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"183a4644","264":"13c64fc0","402":"1cb2c34f","453":"828de7d0","483":"37719b40","497":"79fbed0b","848":"1bf24f26","881":"d1888b0a","917":"47266a50"}[chunkId] + ".chunk.js";
};